/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopsetname2Inputs */

const en__field_workshopsetname2 = /** @type {(inputs: _Field_Workshopsetname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop set`)
};

const de__field_workshopsetname2 = /** @type {(inputs: _Field_Workshopsetname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshop-Reihe`)
};

/**
* | output |
* | --- |
* | "Workshop set" |
*
* @param {_Field_Workshopsetname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopsetname2 = /** @type {((inputs?: _Field_Workshopsetname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopsetname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_workshopsetname2(inputs)
	return de__field_workshopsetname2(inputs)
});
export { _field_workshopsetname2 as "_field_workshopSetName" }